module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_home_welcome_video", [["div",{"id":"flash-player","class":"player"}]]);
fox.registerTemplate("sitepage_home_welcome_banner", [["div",{"class":"uploaded-welcome-banner"},[["img",{"src":"","alt":"welcome"},[],[["src","src",true]]]]],["div",{"class":"welcome-banner-common play-btn-wrapper"},[["if",{"notempty":""},[["a",{"class":"play-btn play"},[["if",{"notempty":"","addattr":"href:&&1&&","addclass":"fake-button"},[],[["useFakePLayer","notempty",true],["welcomeVideo","__internal"]]],["i",{"class":"inf-icon_play_48"}]]]],[["welcomeVideo","notempty",true]]]]]]);
fox.registerTemplate("sitepage_home_welcome_none", [["div",{"data-fox-editor-type":"image"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/welcomevideo.tpl
// module id = 1123
// module chunks = 4